export default __webpack_public_path__ + "static/char-t-21-zh-Hant-22981d854f7a9903ddd8dd602907fcb4.webp";